export default {
  data() {
    return {
      soliData: JSON.parse(localStorage.getItem("plotInfo"))
    };
  },
  computed: {
    soilDataComputed() {
      return this.soliData.greenhouseVoList[0].soilTemperature + '℃/' + this.soliData.greenhouseVoList[0].soilHumidity + '%';
    }
  },
  methods: {
    initChart() {},
    lookDetail() {
      console.log(111);
      this.$emit("lookDetail");
    }
  }
};